import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 93CDBDF3-A4BE-4ADE-9179-171FA94726A6
 * name whistle-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/whistle-outline.svg
 * tags
 * - Sport 
 */
export const WhistleOutlineIcon = createSvgIcon(<><path d="M3.76 3.7L2.14 4.88L4.43 8A8.23 8.23 0 0 1 6.35 7.28M11 9V11H18V11.29L13 12.71V15.5A4.5 4.5 0 1 1 8.5 11H9V9H8.5A6.5 6.5 0 1 0 15 15.5V13.91L22 12V9M16.24 3.7L13.85 7H16.32L17.86 4.88M9 2V7H11V2Z" /></>, 'WhistleOutlineIcon');
export default WhistleOutlineIcon